import React from "react";
import useStringTranslation from "../../../../hooks/useStringTranslation";
import { Typography } from "@mui/material";

export default function CardBody({ species }) {
  const name = useStringTranslation(species, "title");
  return (
    <Typography variant="h6" fontWeight="bold">
      {name}
    </Typography>
  );
}
